// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__QD_U7","alert":"SettungsInbox_alert__3MIuY"};